var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "div",
            { staticClass: "toolbar" },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: "退款单、订单、用户或手机号",
                  size: "small",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.load($event)
                  },
                },
                model: {
                  value: _vm.query.keywords,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.query,
                      "keywords",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "query.keywords",
                },
              }),
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    placeholder: "售后状态",
                    size: "small",
                  },
                  model: {
                    value: _vm.query.refundStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "refundStatus", $$v)
                    },
                    expression: "query.refundStatus",
                  },
                },
                _vm._l(_vm.statusOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    placeholder: "售后类型",
                    size: "small",
                  },
                  model: {
                    value: _vm.query.afterSalesType,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "afterSalesType", $$v)
                    },
                    expression: "query.afterSalesType",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "仅退款", value: 1 } }),
                  _c("el-option", { attrs: { label: "退货退款", value: 2 } }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-search",
                  },
                  on: { click: _vm.load },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.rows, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "refundOrderNo",
                  label: "退款单号",
                  "min-width": "185",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "orderNo", label: "订单号", "min-width": "185" },
              }),
              _c("el-table-column", {
                attrs: { label: "商品", "min-width": "210" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "product-cell" },
                          [
                            _c("el-image", {
                              staticClass: "thumb",
                              attrs: { src: scope.row.productImage },
                            }),
                            _c("div", [
                              _vm._v(_vm._s(scope.row.productName)),
                              _c("div", { staticClass: "muted" }, [
                                _vm._v(_vm._s(scope.row.sku)),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "refundPrice", label: "退款金额", width: "105" },
              }),
              _c("el-table-column", {
                attrs: { label: "类型", width: "105" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.afterSalesType === 2
                              ? "退货退款"
                              : "仅退款"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.statusType(scope.row.refundStatus),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.statusName(scope.row.refundStatus))
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "申请时间",
                  "min-width": "155",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "220", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.showDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        scope.row.refundStatus === 0
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: [
                                      "distribution:store:refund:order:audit",
                                    ],
                                    expression:
                                      "['distribution:store:refund:order:audit']",
                                  },
                                ],
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openAudit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("审核")]
                            )
                          : _vm._e(),
                        scope.row.refundStatus === 5
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: [
                                      "distribution:store:refund:order:receiving",
                                    ],
                                    expression:
                                      "['distribution:store:refund:order:receiving']",
                                  },
                                ],
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openReceive(scope.row)
                                  },
                                },
                              },
                              [_vm._v("收货处理")]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["distribution:store:refund:order:mark"],
                                expression:
                                  "['distribution:store:refund:order:mark']",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openRemark(scope.row)
                              },
                            },
                          },
                          [_vm._v("备注")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.query.page,
              "page-size": _vm.query.limit,
              total: _vm.total,
              layout: "total, sizes, prev, pager, next",
              "page-sizes": [10, 20, 50],
            },
            on: {
              "current-change": _vm.pageChange,
              "size-change": _vm.sizeChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审核售后",
            visible: _vm.auditVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.auditVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "90px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "审核结果" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.action.agree,
                        callback: function ($$v) {
                          _vm.$set(_vm.action, "agree", $$v)
                        },
                        expression: "action.agree",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("同意"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("拒绝"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.action.agree === false
                ? _c(
                    "el-form-item",
                    { attrs: { label: "拒绝理由" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 3 },
                        model: {
                          value: _vm.action.rejectReason,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.action,
                              "rejectReason",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "action.rejectReason",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.auditVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.audit },
                },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退货收货处理",
            visible: _vm.receiveVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.receiveVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "90px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "处理结果" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.receiveAgree,
                        callback: function ($$v) {
                          _vm.receiveAgree = $$v
                        },
                        expression: "receiveAgree",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("确认收货并退款"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("拒绝收货"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.receiveAgree
                ? _c(
                    "el-form-item",
                    { attrs: { label: "拒绝理由" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 3 },
                        model: {
                          value: _vm.action.rejectReason,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.action,
                              "rejectReason",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "action.rejectReason",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.receiveVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.receive },
                },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "门店备注",
            visible: _vm.remarkVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.remarkVisible = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 4,
              maxlength: "500",
              "show-word-limit": "",
            },
            model: {
              value: _vm.action.storeRemark,
              callback: function ($$v) {
                _vm.$set(
                  _vm.action,
                  "storeRemark",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "action.storeRemark",
            },
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.remarkVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.remark },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "售后详情",
            visible: _vm.detailVisible,
            width: "720px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _vm.detail
            ? _c(
                "el-descriptions",
                { attrs: { column: 2, border: "" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "退款单号" } }, [
                    _vm._v(_vm._s(_vm.detail.refundOrderNo)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "订单号" } }, [
                    _vm._v(_vm._s(_vm.detail.orderNo)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "商品", span: 2 } },
                    [
                      _vm._v(_vm._s(_vm.detail.productName || "-")),
                      _vm.detail.sku
                        ? _c("span", [_vm._v(" / " + _vm._s(_vm.detail.sku))])
                        : _vm._e(),
                    ]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "退款件数" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.detail.refundNum != null
                          ? _vm.detail.refundNum
                          : "-"
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "退款金额" } }, [
                    _vm._v("¥" + _vm._s(_vm.detail.refundPrice)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "售后类型" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.detail.afterSalesType === 2 ? "退货退款" : "仅退款"
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "退款方式" } }, [
                    _vm._v("原路退回"),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "状态" } }, [
                    _vm._v(_vm._s(_vm.statusName(_vm.detail.refundStatus))),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "申请时间" } }, [
                    _vm._v(_vm._s(_vm.detail.createTime || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "退款时间" } }, [
                    _vm._v(_vm._s(_vm.detail.refundTime || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "退款原因" } }, [
                    _vm._v(_vm._s(_vm.detail.refundReason || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "用户说明" } }, [
                    _vm._v(_vm._s(_vm.detail.refundExplain || "-")),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "售后凭证", span: 2 } },
                    [
                      _vm.voucherImgs.length
                        ? _vm._l(_vm.voucherImgs, function (img, i) {
                            return _c("el-image", {
                              key: i,
                              staticStyle: {
                                width: "64px",
                                height: "64px",
                                "margin-right": "8px",
                                "border-radius": "4px",
                              },
                              attrs: {
                                src: img,
                                "preview-src-list": _vm.voucherImgs,
                                fit: "cover",
                              },
                            })
                          })
                        : _c("span", [_vm._v("-")]),
                    ],
                    2
                  ),
                  _c("el-descriptions-item", { attrs: { label: "退货物流" } }, [
                    _vm._v(_vm._s(_vm.detail.expressName || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "运单号" } }, [
                    _vm._v(_vm._s(_vm.detail.trackingNumber || "-")),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "拒绝理由", span: 2 } },
                    [_vm._v(_vm._s(_vm.detail.rejectReason || "-"))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "门店备注", span: 2 } },
                    [_vm._v(_vm._s(_vm.detail.storeRemark || "-"))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }